<template>  
  <div>
  <q-card inline style="width: 300px;  background-color: transparent;">
  <q-card-section class="text-h6">
    {{$t('global.NewMaintenanceSchedule')}}  
  </q-card-section>
  <q-card-section>
    <q-input v-model="maintenanceScheduleName" :label="$t('global.Name')"/>
    <q-input
      v-model="description"
      type="textarea"
      :label="$t('global.Description')"
      :max-height="100"
      rows="3"
    />
    <q-select
      v-model="maintenanceGroup"
      :label="$t('global.MaintenanceGroup')"
      :options="maintenanceGroupOptions"
      emit-value map-options
    />

    <q-input v-model="km" type="number" :label="$t('global.KmDue')"/>
    <q-input v-model="days" type="number" :label="$t('global.DayDue')"/>
    <br>
    
    <br>
     <q-btn color="primary" :label="$t('global.Save')" @click="insert()" :disable="disabled" />
     
  </q-card-section>
  
  <q-separator />
</q-card>   
  </div>
</template>

<script>
import {eventBus} from '../../main'
import axios from 'axios'
import qs from 'qs'


export default {
  name: 'SideDialog1',
  data () {
    return {
      form: {
        SessionId: null,
      },
      description: '',
      maintenanceScheduleName: '',
      maintenanceGroup: null,
      maintenanceGroupOptions: [],
      days: null,
      km: null
    }
  },
  methods: {
    insert(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "InsertMaintenanceSchedule"
      this.form.MaintenanceScheduleName = this.maintenanceScheduleName
      this.form.MaintenanceGroupID = this.maintenanceGroup
      this.form.Description = this.description
      this.form.Days = this.days
      this.form.Km = this.km
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
            eventBus.$emit('Bus_ScheduleUpdate', null)  
            this.$q.notify({ message: this.$t('global.MaintenanceCreated', { count: response.data }), type: 'positive'})
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
    },
    loadMaintenanceGroup(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "MaintenanceGroupSelect"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.maintenanceGroupOptions = response.data
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
    }
  
  },
  created () {
    this.loadMaintenanceGroup()
  },
  computed: {
    disabled(){
      if(this.maintenanceScheduleName == '' || this.description == '' || this.maintenanceGroup == null || (this.days == null && this.km == null)){
        return true
      }
      return false
    }
  }
  
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}



</script>

<style>
</style>
